// AI Generated Test
import { Component, Input } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';

@Component({
    selector: 'form-global-policy-pre-content-rule-repeated-short-words',
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    template: `
        <div class="mt-4 mx-4" ngModelGroup="ruleRepeatedShortWords">
            <div class="row">
                <div class="col-24 col-md-30">
                    <div class="card panel-monsido-card">
                        <div class="card-header">
                            <h4 class="font-weight-300" translate>Policy setup</h4>
                        </div>
                        <div class="card-body">
                            <div class="form-group">
                                <label for="policy-pre-content-inputfield" class="col-form-label text-bold text-right capitalize-first-letter">
                                    <span translate>Maximum word length to search for</span>
                                </label>
                                <div class="rule-box-bg">
                                    <div class="row">
                                        <div class="col-40">
                                        <input [(ngModel)]="ngModel"
                                            name="maxWordLength"
                                            type="number"
                                            class="form-control"
                                            id="policy-pre-content-inputfield"
                                            placeholder="{{ 'Insert word length' | translate }}"
                                            (ngModelChange)="onModelChange()"
                                            required
                                            min="1"/>
                                        </div>
                                        <div class="mt-1" translate>
                                            Characters
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-24 col-md-18">
                    <div class="card panel-monsido-card">
                        <div class="card-header">
                            <h4 class="font-weight-300" translate>
                                Information
                            </h4>
                        </div>
                        <div class="card-body">
                            <p>
                                <strong translate>How to setup this policy:</strong>
                            </p>
                            <p translate>Define a maximum character count to search for in a word. Shorter words will not be flagged. For example, if you input "6" as the max. length,
                                we look for any repeated words that are between 1-6 characters.</p>
                            <p translate>Edit this policy rule later under the "Add rule to policy" tab.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `,
    standalone: false,
})
export class FormGlobalPolicyPreContentRuleRepeatedShortWordsComponent {
    @Input() model: any;
    ngModel: any = null;

    onModelChange () {
        this.model = [
            {
                name: 'Repeated words of ' + parseInt(this.ngModel) + ' characters long or shorter',
                case_sensitive: true,
                inverse: false,
                operator: 'regex',
                query: '\\p{Space}(\\p{Word}{,' + parseInt(this.ngModel) + '})\\p{Space}\\1',
                type: 'page_text',
                sub_entry: '',
            },
        ];
    }
}
